import axios from 'axios';

const errorParser = errorResponse => {
  try {
    const objs = JSON.parse(errorResponse);
    return {
      msg: objs.data?.description ?? objs?.msg ?? 'Something went wrong',
      obj: objs
    };
  } catch (error) {
    return {
      msg: errorResponse,
      obj: {}
    };
  }
};

export const getBizLocations = async ({ base_url, userToken }) => {
  try {
    const { data } = await axios({
      method: 'GET',
      url: base_url + '/setup/biz/locations',
      headers: {
        'Content-Type': 'application/json',
        'x-access-tokens': userToken
      }
    });

    return {
      success: true,
      data
    };
  } catch (error) {
    const errorObj = errorParser(error.request.response);
    return {
      success: false,
      error: {
        ...errorObj
      }
    };
  }
};

export const addBizLocation = async ({ base_url, userToken, body }) => {
  try {
    const { data } = await axios({
      method: 'POST',
      url: base_url + '/setup/biz/locations/add',
      headers: {
        'Content-Type': 'application/json',
        'x-access-tokens': userToken
      },
      data: body
    });

    return {
      success: true,
      data
    };
  } catch (error) {
    const errorObj = errorParser(error.request.response);
    return {
      success: false,
      error: {
        ...errorObj
      }
    };
  }
};

export const updateBizLocation = async ({ base_url, userToken, body }) => {
  try {
    const { data } = await axios({
      method: 'POST',
      url: base_url + '/setup/biz/locations/update',
      headers: {
        'Content-Type': 'application/json',
        'x-access-tokens': userToken
      },
      data: body
    });

    return {
      success: true,
      data
    };
  } catch (error) {
    const errorObj = errorParser(error.request.response);
    return {
      success: false,
      error: {
        ...errorObj
      }
    };
  }
};

export const deleteBizLocation = async ({
  base_url,
  userToken,
  ixLocation
}) => {
  try {
    const { data } = await axios({
      method: 'POST',
      url: base_url + '/setup/biz/locations/delete',
      headers: {
        'Content-Type': 'application/json',
        'x-access-tokens': userToken
      },
      data: { ixLocation }
    });

    return {
      success: true,
      data
    };
  } catch (error) {
    const errorObj = errorParser(error.request.response);
    return {
      success: false,
      error: {
        ...errorObj
      }
    };
  }
};

export const getTransBizLocations = async ({ base_url, userToken }) => {
  try {
    const { data } = await axios({
      method: 'GET',
      url: base_url + '/trans/biz/locations',
      headers: {
        'Content-Type': 'application/json',
        'x-access-tokens': userToken
      }
    });

    return {
      success: true,
      data
    };
  } catch (error) {
    const errorObj = errorParser(error.request.response);
    return {
      success: false,
      error: {
        ...errorObj
      }
    };
  }
};
